import(/* webpackMode: "eager" */ "/app/src/app/compare/powerbi/page.tsx");
